// extracted by mini-css-extract-plugin
export default {"outline":"level-icon_outline__Z5hcH","outline--visible":"level-icon_outline--visible__mrjDH","background":"level-icon_background__rHQez"};